import React from 'react'

import { Col, Form } from '_zari/core'

import { SelectCentroCostoNivel2 } from 'sharedComponents/select'

import { Field } from 'formik'

const CentroCostoNivel2FormGroup = ({ iError, iTouched, fIsSubmitting, idNodoPadre }) => {
  return (
    <Form.Group>
      <Form.Label text='C. COSTO 2' htmlFor='select-centroCostoNivel2' md={12} />
      <Col md={12}>
        <Field name='_idCentroCostoNivel2'>
          {({ field }) => (
            <SelectCentroCostoNivel2
              {...field}
              id='select-centroCostoNivel2'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              idNodoPadre={idNodoPadre}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CentroCostoNivel2FormGroup)
